import React from 'react'
import ACHTransferForm from '../../components/ACHTransferForm'
import { Formik } from 'formik'
import { achTransferSchema } from '../../components/ACHTransferForm/achTransferValidations'
import { ACHTransferValues } from '../../components/ACHTransferForm/types'
import { CashDirection, TransferMechanism } from '@Types'
import useGetIraConstraints from '../../api/useGetIRAConstraints'
import { useGetAchRel } from '../../api/useGetAchRel'
import useAccount from '../../hooks/useAccount'

export interface ACHTransfersProps {
  amountAvailable: number
  hasSubmitPermission: boolean
}

const ACHTransfers = ({ amountAvailable, hasSubmitPermission }: ACHTransfersProps) => {
  const { account } = useAccount()
  const { isLoading: achRelLoading, isFetching } = useGetAchRel(account?.accountNumber!)
  const { error: withdrawConstraintsLoadingError, data: withdrawConstraints } = useGetIraConstraints(
    'withdrawalIraConstraints',
    TransferMechanism.Ach,
    account?.accountNumber!,
    CashDirection.Withdrawal
  )
  const { error: depositConstraintsLoadingError, data: depositConstraints } = useGetIraConstraints(
    'depositIraConstraints',
    TransferMechanism.Ach,
    account?.accountNumber!,
    CashDirection.Deposit
  )

  if (withdrawConstraintsLoadingError || depositConstraintsLoadingError)
    return <div>Error Loading IRA Constraints...</div>

  const iraConstraints = {
    contributionConstraints: depositConstraints?.contributionConstraints,
    distributionConstraints: withdrawConstraints?.distributionConstraints,
    retirementAccount: depositConstraints?.retirementAccount || false
  }

  if (account && withdrawConstraints && !achRelLoading && !isFetching) {
    const defaultValues = {
      amountAvailable,
      accountNumber: account.accountNumber
    }

    const formikConfig = {
      initialValues: achTransferSchema(defaultValues, iraConstraints).cast({}),
      onSubmit: (values: ACHTransferValues) => {},
      validationSchema: () => achTransferSchema(defaultValues, iraConstraints),
      validateOnMount: true,
      validateOnChange: true,
      validateOnBlur: true
    }
    return (
      <Formik {...formikConfig}>
        <ACHTransferForm
          amountAvailable={amountAvailable}
          account={account}
          iraConstraints={iraConstraints}
          hasSubmitPermission={hasSubmitPermission}
        />
      </Formik>
    )
  }
  return <div>Loading...</div>
}

export default ACHTransfers
